<template>
  <div>
    <ft-navbar></ft-navbar>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Einzelstücke <span class="text-muted">({{filtered.length}}/{{specials.length}})</span>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ul>
              <li>In unserem Lager haben wir eine grosse Auswahl an Spezialitäten, welche jederzeit gerne besichtigt
                werden können.
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Es können auch runde Säulenverkleidungen hergestellt werden. Diese können aus rein optischen Gründen
                angebracht werden oder dienen als Brandschutzverkleidung bis Ei90.
              </li>
            </ul>
          </div>
        </div>
        <div class="row my-5">
          <b-form inline>
            <b-form-input type="text" placeholder="Nummer (z.B. 1002)" v-model="mnumber"></b-form-input>
          </b-form>
        </div>
        <div class="row">
          <grid min="240px" v-if="filtered.length">
            <div class="scard" v-for="spec in filtered" :key="spec.model">
              <div v-if="spec.thumbnail" @click="showDetail(spec)" class="scard-img-cnt">
                <b-img-lazy :src="spec.thumbnail" blank-width="200" blank-height="200" blank-color="#212529"
                            :alt="title(spec)"
                            class="scard-img-top img-fluid"/>
              </div>
              <div class="scard-body">
                <h4 class="scard-title">{{title(spec)}}</h4>
                <ul class="list-unstyled">
                  <li v-html="spec.description"></li>
                </ul>
              </div>
            </div>
          </grid>
          <div class="m-auto" v-else>
            <spinner></spinner>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="detailModalRef" hide-footer centered size="lg">
      <spinner v-if="imgLoading"></spinner>
      <b-img fluid :src="detailImage" @load="imgLoaded"/>
    </b-modal>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'
import Spinner from '@/components/Spinner'
import axios from 'axios'

export default {
  name: 'Einzelstuecke',
  components: {ftNavbar, Grid, Spinner},
  data () {
    return {
      specials: [],
      style: 0,
      mnumber: null,
      detailImage: null,
      imgLoading: true
    }
  },
  computed: {
    filtered () {
      let filteredSpec = this.specials

      if (this.mnumber) {
        return filteredSpec.filter(m => ('' + m.model).indexOf('' + this.mnumber) === 0)
      }

      return filteredSpec
    }
  },

  methods: {
    title (obj) {
      return `SPZ${obj.model}`
    },
    showDetail (r) {
      if (this.detailImage !== r.detail) {
        this.detailImage = ''
        this.imgLoading = true
        this.detailImage = r.detail
      }
      this.$refs.detailModalRef.show()
    },
    imgLoaded () {
      this.imgLoading = false
    }
  },
  mounted () {
    axios.get(`${this.$api}/einzelstueck/list/`)
      .then(response => {
        this.specials = response.data.models
        this.styles = response.data.styles
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Einzelstuecke.vue